module.exports = __webpack_public_path__ + "media/images/rounded-hexagon-cc92815d9211e04ce68fda542a6a972f.svg";